import { useQuery } from "react-query";
import type { Account } from "types/generated";
import api from "../api";

const getAccount = async () => {
  const { data } = await api.get<Account>("/account");

  return data;
};

export const useGetAccountQuery = () => {
  return useQuery<Account>("get-account", getAccount);
};
